import styled from "style/styled-components";
import SpreadRow from "components/generic/SpreadRow";

const CenteredSpreadRow = styled(SpreadRow)`
  align-items: center;
`;

export default CenteredSpreadRow;
